module.exports = __webpack_public_path__ + "img/silverado1500-20.a17b652a.png";